import { render, staticRenderFns } from "./news.vue?vue&type=template&id=43373180&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"
import style0 from "./news.vue?vue&type=style&index=0&id=43373180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43373180",
  null
  
)

export default component.exports